import scan from "./scan_icon_dark_16px.png";

export const ScanIcon = () => <img src={scan} alt="Scan icon" />;
